import React, { Fragment } from "react";
import constants from "../../../constants";

const CcSecQnsUtils = ({
  item,
  count,
  onClick,
  activeCard,
  setActiveCard,
  notClickable = false,
  className,
}) => {
  // console.log("item", item);

  return (
    <div
      style={{
        borderRadius: "12px",
        // background: "linear-gradient(103.23deg, #8ccdd3 3.04%, #999999 93.29%)",
      }}
    >
      <div
        key={item.key}
        className={`ccSecQnsUtilContainer ${item.key} ${
          activeCard !== null && activeCard !== item.key ? "blur" : ""
        } ${className}`}
        style={item.style}
        // onMouseEnter={() => setActiveCard(item.key)}
        // onMouseLeave={()=>setActiveCard()}
        onClick={() => {
          if (notClickable) {
            return;
          } else {
            onClick(item.filValue);
            if (item?.key === "totalCount") {
              setActiveCard(null);
            } else {
              setActiveCard(item.key);
            }
          }
        }}
      >
        <div className="ccSecQnsUtilTopSec">
          <p className="ccSecQnsUtilTitle">{item.title}</p>
          <div
            dangerouslySetInnerHTML={{
              __html: item.icon,
            }}
          />
        </div>
        <div className="ccSecQnsUtilBottomSec">
          <p className="ccSecQnsUtilCount">
            {typeof count === "object" ? count.totalCount : count}
            {/* {console.log("typeof:",typeof count)} */}
          </p>
          {item.showCategoryCount ? (
            <Fragment>
              <Category cateCountData={count?.categoryCount} />
            </Fragment>
          ) : (
            <div className="categoryContainer"></div>
          )}
        </div>
      </div>
    </div>
  );
};

export default CcSecQnsUtils;

const Category = ({ cateCountData = [] }) => {
  const getCategoryCount = (category) => {
    // console.log("cateCountData",cateCountData,"category:",category);
    const sortedCateCountData = cateCountData.sort((a, b) => a.name - b.name);
    // console.log("sortedData:",sortedCateCountData);

    const data = sortedCateCountData.filter(
      (item) =>
        item?.name?.toLowerCase() ===
        (category?.toLowerCase() === "hard"
          ? "difficult"
          : category?.toLowerCase())
    );
    // console.log("data:",data);

    if (data.length) return String(data[0].count ?? 0);
    return String(0);
  };

  return (
    <div className="categoryContainer">
      {Object.entries(constants.complexityid)
        .sort((a, b) => a[1] - b[1])
        .map(([key, value], index) => (
          <Fragment key={index}>
            {/* {console.log("key:", key)} */}
            <div key={index} className={`categoryItem ${key.toLowerCase()}`}>
              {getCategoryCount(key)} <br />
              <span className="categoryItemName">{key.toLowerCase()}</span>
            </div>
            {index !== Object.entries(constants.complexityid).length - 1 && (
              <hr />
            )}
          </Fragment>
        ))}
    </div>
  );
};
